import { c as _c } from "react/compiler-runtime";
import React from 'react';
// eslint-disable-next-line import/no-unresolved
import Masonry from 'react-masonry-css';
const SIDEBAR_OPEN_BREAKPOINTS = {
  default: 3,
  1519: 1
};

// Breakpoint columns for when sidebar is closed (responsive)
const SIDEBAR_CLOSED_BREAKPOINTS = {
  default: 4,
  1440: 3,
  1100: 2,
  700: 1
};
const JoybirdMasonryComponentNew = t0 => {
  const $ = _c(5);
  const {
    photoCardsList,
    isSidebarOpen: t1
  } = t0;
  const isSidebarOpen = t1 === undefined ? false : t1;
  const breakpointColumnsObj = isSidebarOpen ? SIDEBAR_OPEN_BREAKPOINTS : SIDEBAR_CLOSED_BREAKPOINTS;
  let t2;
  if ($[0] !== photoCardsList) {
    t2 = photoCardsList.map(_temp);
    $[0] = photoCardsList;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== breakpointColumnsObj || $[3] !== t2) {
    t3 = <Masonry breakpointCols={breakpointColumnsObj} className="flex w-full box-border" columnClassName="bg-clip-padding">{t2}</Masonry>;
    $[2] = breakpointColumnsObj;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default JoybirdMasonryComponentNew;
function _temp(card, idx) {
  return <div key={card.key || idx} style={{
    width: "100%"
  }}>{card}</div>;
}